import { compareDesc } from "date-fns";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { PublicationRecord } from "./PublicationRecord";

import { type PublicationType } from "components/server-types";
import { t } from "i18n/i18n";

interface PublicationHistoryProps {
  completedPublications: PublicationType[];
  className?: string;
}

export const PublicationHistory: FC<PublicationHistoryProps> = ({
  completedPublications,
  className,
}) => {
  const sortedData = [...completedPublications].toSorted((a, b) =>
    compareDesc(a.published_at ?? 0, b.published_at ?? 0),
  );

  return (
    <div className={twMerge("flex flex-col gap-4", className)}>
      <h3 className="h3 mb-2 text-black-tint-20">{t("publishing.publication_history")}</h3>
      {sortedData.map((publication) => (
        <PublicationRecord key={publication.id} publication={publication} />
      ))}
    </div>
  );
};
